import { render, staticRenderFns } from "./column-title.vue?vue&type=template&id=629dd8cc&scoped=true"
import script from "./column-title.vue?vue&type=script&lang=js"
export * from "./column-title.vue?vue&type=script&lang=js"
import style0 from "./column-title.vue?vue&type=style&index=0&id=629dd8cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629dd8cc",
  null
  
)

export default component.exports